import { useRef, useState, useEffect, useContext } from 'react';
import AuthContext from '../../context/authProvider';
import api from '../../api/axios';
import styles from './LoginForm.module.css';
import { useNavigate } from 'react-router-dom';
import ForgotPassword from '../../components/ForgotPassword/ForgotPassword';
import PasswordInput from '../../components/PasswordInput/PasswordInput';

// const LOGIN_URL = '/api/v1/login';
const LOGIN_URL = '/login';

const LoginForm1 = () => {
  const { setAuth } = useContext(AuthContext);
  const userRef = useRef();
  const errRef = useRef();

  const [user, setUser] = useState('');
  const [pwd, setPwd] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  const navigate = useNavigate();

  //User focus
  useEffect(() => {
    userRef.current.focus();
  }, [])

  //Reset error message
  useEffect(() => {
    setErrMsg('');
  }, [user, pwd])

  //Backend forgot password
  const handleForgotPassword = async (email) => {
    try {
      await api.post('/forgot-password', { email });
      alert('If this email is registered, a reset link has been sent.');
      setShowForgot(false);
    } catch (error) {
      alert('Something went wrong. Please try again.');
      console.error(error);
    }
  };

  //Backend submit function
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post(LOGIN_URL,
        JSON.stringify({username: user, user_password: pwd}),
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true
        }
      );
      const accessToken = response?.data?.accessToken;
      const roles = response?.data?.roles;
      setAuth({ user, pwd, roles, accessToken });
      setUser('');
      setPwd('');
      localStorage.setItem("jwtToken", accessToken);
      setSuccess(true);
      navigate('/recruits');
    } catch (err) {
        console.error('Login error:', err);
        // safe checks using optional chaining
        if (!err?.response) {
          setErrMsg('No server response. Please try again later.');
        } else if (err.response.status === 400) {
          setErrMsg('Missing username or password. Please try again.');
        } else if (err.response.status === 401) {
          setErrMsg('Incorrect username or password.');
        } else {
          setErrMsg('Login failed. Please try again.');
        }
      errRef.current?.focus();
    }
  }

  //Frontend visuals
  return (
    <div className={styles.pageWrapper}>
      <section className={styles.loginBox}>
        <h1 className={styles.loginTitle}>Login</h1>
        <p className={styles.loginSubtitle}>Enter your credentials to access your account</p>

        <form onSubmit={handleSubmit} className={styles.loginForm}>
          {/*Error message*/}
          <p ref={errRef} className={errMsg ? styles.errorMsg : "offscreen"} aria-live="assertive">{errMsg}</p>

          {/*Username*/}
          <div className={`${styles.inputGroup} ${styles.usernameGroup}`}>
            <label htmlFor="username" className={styles.inputLabel}>Username</label>
            <input
              type="text"
              id="username"
              ref={userRef}
              autoComplete="username"
              onChange={(e) => setUser(e.target.value)}
              value={user}
              required
              className={`${styles.inputField} ${errMsg ? styles.inputError : ''}`}
              aria-invalid={!!errMsg}
            />
          </div>

          {/*Password*/}
          <div className={`${styles.inputGroup} ${styles.passwordInput}`}>
            <label htmlFor="password" className={styles.inputLabel}>Password</label>
            <PasswordInput
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              autoComplete = "current-password"
              error={errMsg}
            />
          </div>

          {/*Submit*/}
          <button type="submit" className={styles.loginButton}>
            <span className={styles.signInText}>Login →</span>
          </button>

          {/*Forgot password*/}
          <div className={styles.forgotPassword}>
            <a
              href="#"
              className={styles.forgotLink}
              onClick={(e) => {
                e.preventDefault();
                setShowForgot(true);
              }}
            >
              Forgot password?
            </a>
          </div>

          {showForgot && (
            <ForgotPassword
              onClose={() => setShowForgot(false)}
              onSend={handleForgotPassword}
            />
          )}
        </form>

        {/*Forgot username and signup*/}
        <div className={styles.extraLinks}>
          <p>Forgot username?</p>
          <p>Don't have an account? <a href="/signup">Sign up</a></p>
        </div>
      </section>
    </div>
  );
};

export default LoginForm1;